import Chart from 'chart.js';
import * as ChartAnnotation from 'chartjs-plugin-annotation';

Chart.defaults.global.legend.display = false;
Chart.defaults.global.tooltips.enabled = false;

class CoalitionChart {
  BG_COLOR = ['#999', '#999', '#999', '#999', '#999', '#999'];
  LABELS = ['SPD', 'GRÜNE', 'CDU', 'DIE LINKE', 'AfD', 'FDP'];

  constructor(props) {
    this.ctx = props.ctx;
    this.config = props.config;
    this.toggles = props.toggles;
    this.colorBlockMaxHeight = 250;
    this.chart = null;
    this.originalColors = [];
  }

  setToggleHeight = () => {
    this.toggles.forEach(toggle => {
      const colorBlock = toggle.querySelector('.color-block');
      const dataHeight = colorBlock.dataset.seats;
      const divideBy = window.innerWidth < 1100 ? 40 : 100;
      colorBlock.style.height = `${(this.colorBlockMaxHeight / divideBy) *
      dataHeight}px`;
    });
  };

  bindEvents = () => {
    this.toggles.forEach(toggle => {
      const title = toggle.querySelector('.title').innerText;
      const labels = this.chart.data.labels;

      toggle.addEventListener('click', () =>
        this.toggleDataChart(toggle, title, labels)
      );
    });
  };

  toggleDataChart = (toggle, title, labels) => {
    const datas = this.chart.data.datasets[0].data;
    const colors = this.chart.data.datasets[0].backgroundColor;

    // get index of current item
    const index = labels.indexOf(`${title}`);

    if (!toggle.classList.contains('in')) {
      // select item: if item was not previously selected, move it to the first position of the chart and add color of respective party
      toggle.classList.add('in');
      toggle.classList.remove('out');

      // move labels, seats and color to the first position of the array
      const label = labels.splice(index, 1);
      labels.unshift(...label);
      const seats = datas.splice(index, 1);
      datas.unshift(...seats);
      const color = toggle.getAttribute('data-color');
      colors.unshift(color);
      colors.pop();

      this.chart.data.labels = labels;
      this.chart.data.datasets[0].backgroundColor = colors;
      this.chart.data.datasets[0].hoverBackgroundColor = colors;
      this.chart.data.datasets[0].data = datas;

      this.chart.update();
    } else {
      // remove item: move it to the end of the chart's arrays and set it's color to grey again
      toggle.classList.remove('in');
      toggle.classList.add('out');

      // move item to the end of the arrays
      const newLabelArray = labels.splice(index, 1);
      labels.push(...newLabelArray);
      const newBackgroundColorArray = colors.splice(index, 1);
      colors.push(...newBackgroundColorArray);
      const newDataArray = datas.splice(index, 1);
      datas.push(...newDataArray);

      this.chart.data.labels = labels;
      this.chart.data.datasets[0].backgroundColor = colors;
      // set item's color to grey again
      this.chart.data.datasets[0].backgroundColor[labels.length - 1] = '#999';
      this.chart.data.datasets[0].data = datas;
      this.chart.update();
    }
  };


  initChart = () => {
    this.chart = new Chart(ctx, config);
    console.log(this.chart);

    if (window.innerWidth < 700) {
      document.querySelector('.centered').scrollIntoView({ inline: 'center' });
    }
    this.bindEvents();
  };

  init = () => {
    this.initChart();
    this.setToggleHeight();
  };
}

// initialize chart with items greyed out
const ctx = document.getElementById('coalitionChart');
const toggles = [...document.querySelectorAll('.toggle-political-btn')];
const config = {
  type: 'doughnut',
  data: {
    datasets: [
      {
        data: [54, 33, 15, 13, 7, 1],
        backgroundColor: ['#999', '#999', '#999', '#999', '#999', '#999'],
        hoverBackgroundColor: ['#999', '#999', '#999', '#999', '#999', '#999'],
        borderColor: '#999',
        hoverBorderColor: '#999',
        borderWidth: [-1, -1, -1, -1, -1, -1],
      },
    ],
    labels: ['SPD', 'GRÜNE', 'CDU', 'DIE LINKE', 'AfD', 'FDP'],
  },
  options: {
    responsive: true,
    circumference: Math.PI,
    rotation: -Math.PI,
    legend: {
      display: false,
    },
    animation: {
      animateScale: false,
      animateRotate: false,
    },
    title: {
      display: false,
    },
    annotation: {
      annotations: [
        {
          drawTime: 'afterDatasetsDraw',
          type: 'line',
          mode: 'vertical',
          scaleID: 'x-axis-0',
          value: 5,
          lineWidth: 1,
          endValue: 5,
          borderWidth: 5,
          borderColor: 'black',
          borderDash: [10, 5],
          label: {
            content: 'Mehrheit der Sitze',
            enabled: false,
            position: 'top',
          },
        },
      ],
    },
    scales: {
      xAxes: [
        {
          type: 'linear',
          position: 'bottom',
          display: false,
          ticks: {
            beginAtZero: true,
            steps: 10,
            stepValue: 1,
            max: 10,
          },
        },
      ],
      yAxes: [
        {
          type: 'linear',
          position: 'bottom',
          display: false,
          ticks: {
            beginAtZero: true,
            steps: 10,
            stepValue: 1,
            max: 10,
          },
        },
      ],
    },
  },
};

if (ctx) {
  new CoalitionChart({
    ctx,
    config,
    toggles,
  }).init();
}

